import Theme from '../../theme';
import React from 'react';
import { translate } from 'react-i18next';
import { Button, ButtonTypes } from '../../components';

const BodyCompositionButtonComponent = ({ t, showBodyGroups, containerStyle }) => {
    return <Button
        title={t('changeMyBodyMetrics')}
        onPress={showBodyGroups}
        fontColor={Theme.PRIMARY}
        buttonType={ButtonTypes.TRANSPARENT}
        containerStyle={containerStyle}
    />;
};

export const BodyCompositionButton = translate(['bodyscan'])(BodyCompositionButtonComponent);
